export enum AgreementKeyTermStatus {
    NA = "N/A",
    VIEW = "View",
    REQUEST = "Request Key Terms",
    REQUEST_SENT = "Request Sent",
}